module.exports = __webpack_public_path__ + "media/images/simulation/ic_print-a0208f0e00b3d464545fa6112f407285.svg";